import React from 'react';
import { ConsumerGroupOrderFieldsFragment } from 'src/gqlReactTypings.generated.d';
import { useMessaging } from 'src/pages/consumer/account/orders/useMessaging';
import { ConsumerGroupOrderMessageModal } from './ConsumerGroupOrderMessageModal';
import { OrdersListRowMessageButton } from './styles';

interface Props {
  groupOrder: ConsumerGroupOrderFieldsFragment;
}

export const MessageButton = ({ groupOrder }: Props) => {
  const { hideMessageModal, isMessageModalShowing, onMessageButtonClick, shouldShowMessageButton, openChatWidget } =
    useMessaging(groupOrder);

  if (groupOrder.canReviewOrder || !shouldShowMessageButton) {
    return null;
  }

  return (
    <>
      <OrdersListRowMessageButton
        onClick={(event: React.MouseEvent<HTMLButtonElement>) => {
          event.preventDefault();
          onMessageButtonClick();
        }}>
        Message
      </OrdersListRowMessageButton>

      {isMessageModalShowing && (
        <ConsumerGroupOrderMessageModal
          groupOrder={groupOrder}
          onClose={hideMessageModal}
          openChatWidget={openChatWidget}
        />
      )}
    </>
  );
};
